"use client";

import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function EmpoweringAfricanExcellence() {
  const {
    ref: leftRef,
    isVisible: leftVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const {
    ref: rightRef,
    isVisible: rightVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const materials = ["ARTIFICIAL INTELLIGENCE", "STRATEGIC LEADERSHIP", "DIGITAL MARKETING", "CORPORATE STRATEGY", "BUSINESS INNOVATION", "EXECUTIVE EXCELLENCE"];
  return <section data-section-id="355" id="empowering-african-excellence" className="dark bg-background text-foreground relative overflow-hidden min-h-[90vh] flex items-center">
      {}
      <div className="pointer-events-none absolute inset-0 opacity-[0.04] mix-blend-overlay" style={{
      backgroundImage: "url(\"data:image/svg+xml,%3Csvg viewBox='0 0 200 200' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='3'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)'/%3E%3C/svg%3E\")"
    }} aria-hidden="true" />

      <div className="relative w-full max-w-[1440px] mx-auto px-6 md:px-10 lg:px-16 py-20 lg:py-0">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-12 items-center">
          {}
          <div ref={leftRef} data-index={0} className={`lg:col-span-5 transition-all duration-1000 ease-out ${leftVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
            {}
            <div className="flex items-center gap-3 mb-8">
              <span className="h-px w-8" style={{
              backgroundColor: "var(--secondary)"
            }} aria-hidden="true" />
              <span className="font-mono text-[10px] md:text-[11px] tracking-[0.25em] uppercase" style={{
              color: "var(--secondary)"
            }}>Est. 2024 — Innovation Hub</span>
            </div>

            {}
            <h1 className="font-default font-light text-foreground leading-[0.95] tracking-tight mb-8" style={{
            fontSize: "clamp(3.5rem, 7vw, 6.5rem)"
          }}>
              Empowering African{" "}
              <span className="italic font-normal" style={{
              color: "var(--primary)"
            }}>
                excellence
              </span>
            </h1>

            {}
            <p className="font-default text-[18px] md:text-[19px] leading-relaxed text-muted-foreground max-w-md mb-10">
              Equipping the next generation of leaders with practical, high-impact business innovation skills.
            </p>

            {}
            <div className="flex flex-col sm:flex-row items-start sm:items-center gap-5 sm:gap-8">
              <Button asChild size="lg" className="font-default text-base px-8 py-6 h-auto tracking-wide bg-secondary text-secondary-foreground hover:bg-secondary/90 rounded-lg shadow-lg">
                <Link to="/OurProgramsPage">Explore our programs</Link>
              </Button>

              <Link to="#" className="font-default text-base text-foreground hover:text-primary transition-colors inline-flex items-center gap-2 group border-b border-border hover:border-primary/40 pb-1">
                Read our story
                <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" />
              </Link>
            </div>

            {}
            <div className="hidden lg:flex items-center gap-4 mt-16">
              <span className="h-px w-12" style={{
              backgroundColor: "var(--primary)",
              opacity: 0.5
            }} aria-hidden="true" />
              <span className="font-mono text-[10px] tracking-[0.3em] uppercase" style={{
              color: "var(--muted-foreground)"
            }}>
                Based in Accra, Ghana
              </span>
            </div>
          </div>

          {}
          <div ref={rightRef} data-index={1} className={`lg:col-span-7 relative transition-all duration-1000 ease-out delay-200 ${rightVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
            <div className="relative flex justify-center lg:justify-end">
              {}
              <div className="hidden md:flex absolute -right-2 lg:right-0 top-1/2 -translate-y-1/2 translate-x-6 lg:translate-x-10 items-center gap-3 z-10">
                <div className="h-24 w-px" style={{
                backgroundColor: "var(--secondary)"
              }} aria-hidden="true" />
                <span className="font-mono text-[10px] tracking-[0.3em] uppercase whitespace-nowrap" style={{
                color: "var(--secondary)",
                writingMode: "vertical-rl",
                transform: "rotate(180deg)"
              }}>
                  Scroll to learn
                </span>
              </div>

              {}
              <div className="relative w-full max-w-[560px] aspect-[3/4] overflow-hidden rounded-lg shadow-2xl">
                {}
                <div className="absolute top-0 left-0 w-10 h-px z-20" style={{
                backgroundColor: "var(--secondary)"
              }} />
                <div className="absolute top-0 left-0 h-10 w-px z-20" style={{
                backgroundColor: "var(--secondary)"
              }} />
                <div className="absolute bottom-0 right-0 w-10 h-px z-20" style={{
                backgroundColor: "var(--secondary)"
              }} />
                <div className="absolute bottom-0 right-0 h-10 w-px z-20" style={{
                backgroundColor: "var(--secondary)"
              }} />

                <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1696678/img/executive_leadership_training_session.webp" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1696678/img/executive_leadership_training_session.webp-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1696678/img/executive_leadership_training_session.webp-wvc-sizes" alt="Executive professionals collaborating in a modern African business school environment" loading="lazy" decoding="async" className="absolute inset-0 w-full h-full object-cover" src="https://abisafrica.org/wp-content/uploads/2026/06/WhatsApp-Image-2026-06-15-at-15.03.38.jpeg" src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1696678/img/startup-software-developers-doing-brainstorming-office-scaled-1.png" src="https://abisafrica.org/wp-content/uploads/2026/06/WhatsApp-Image-2026-06-05-at-21.50.26-1.jpeg" src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1696678/img/executive_leadership_training_session.webp" />

                {}
                <div className="absolute inset-0 pointer-events-none" style={{
                background: "linear-gradient(to bottom, transparent 60%, hsla(0, 75%, 10%, 0.45) 100%)"
              }} aria-hidden="true" />

                {}
                <div className="absolute bottom-5 left-5 z-20">
                  <span className="font-mono text-[10px] tracking-[0.25em] uppercase" style={{
                  color: "var(--background)"
                }}>
                    Module N°01 — AI Strategy
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>

        {}
        <div className="mt-16 lg:mt-20 relative overflow-hidden border-t border-border pt-6">
          <div className="flex items-center gap-3 mb-4">
            <span className="font-mono text-[10px] tracking-[0.3em] uppercase" style={{
            color: "var(--secondary)"
          }}>
              Core Competencies
            </span>
            <span className="h-px flex-1" style={{
            backgroundColor: "var(--border)"
          }} aria-hidden="true" />
          </div>

          <div className="relative overflow-hidden">
            <div className="flex gap-12 animate-[ticker_40s_linear_infinite] whitespace-nowrap">
              {[...materials, ...materials, ...materials].map((material, i) => <div key={i} data-index={i} className="flex items-center gap-12 shrink-0">
                  <span className="font-mono text-[11px] md:text-xs tracking-[0.3em] uppercase text-muted-foreground">
                    {material}
                  </span>
                  <span className="h-1 w-1 rounded-lg shrink-0" style={{
                backgroundColor: "var(--secondary)"
              }} aria-hidden="true" />
                </div>)}
            </div>
          </div>
        </div>
      </div>

      <style>{`
        @keyframes ticker {
          0% { transform: translateX(0); }
          100% { transform: translateX(-33.333%); }
        }
      `}</style>
    </section>;
}